import { SMART_DELAY_UNITS } from '../../../flowConstants';

export default function SmartDelayNode({ id, data }) {
    const smartDelayMin = data?.smartDelayMin ?? '';
    const smartDelayMax = data?.smartDelayMax ?? '';
    const smartDelayUnit = data?.smartDelayUnit || 'seconds';
    const showTyping = Boolean(data?.showTyping);

    return (
        <div className="mt-2 space-y-2">
            <div className="grid grid-cols-3 gap-2">
                <div className="col-span-2 flex items-center gap-1">
                    <input type="number" min="1" step="1" className="input3" placeholder="Min"
                        value={smartDelayMin}
                        onChange={(e) => data?.onChangeSmartDelay?.(id, { smartDelayMin: e.target.value })} />
                    Até
                    <input type="number" min="1" step="1" className="input3" placeholder="Max"
                        value={smartDelayMax}
                        onChange={(e) => data?.onChangeSmartDelay?.(id, { smartDelayMax: e.target.value })} />
                </div>
                <select className="form-select w-full" value={smartDelayUnit}
                    onChange={(e) => data?.onChangeSmartDelay?.(id, { smartDelayUnit: e.target.value })}>
                    {SMART_DELAY_UNITS.map((unit) => (
                        <option key={unit.value} value={unit.value}>{unit.label}</option>
                    ))}
                </select>
            </div>
            <label className="flex items-center gap-2 text-[10px] text-gray-300">
                <input type="checkbox" className="h-3 w-3 rounded border-white/20 bg-white/10"
                    checked={showTyping}
                    onChange={(e) => data?.onChangeSmartDelay?.(id, { showTyping: e.target.checked })} />
                <span>Mostrar digitando</span>
            </label>
        </div>
    );
}
